import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import Btn from "../Btn";
import "./styles.scss";

const MiniService = ({ data, isActive, onSelect }) => {
	return (
		<div className="miniService_wrap">
			<motion.div
				onClick={onSelect}
				className="miniService"
				whileHover={{ y: -4 }}
				transition={{ duration: 0.2, ease: "easeOut" }}
			>
				<Link to="/servicios" aria-label={`Ver ${data.title}`}>
					<div className="imgCircleBg">
						<img src={data.img} alt="" loading="lazy" />
					</div>
				</Link>
				<h2>{data.title}</h2>
				<Link to="/servicios">
					<Btn>Más información</Btn>
				</Link>
			</motion.div>
			<AnimatePresence>
				{isActive ? (
					<motion.div
						className="miniService_phone"
						initial={{ opacity: 0, height: 0 }}
						animate={{ opacity: 1, height: "auto" }}
						exit={{ opacity: 0, height: 0 }}
						transition={{ duration: 0.25, ease: "easeOut" }}
					>
						<p>{data.description}</p>
						<Link to="/servicios">
							<Btn>Más información</Btn>
						</Link>
					</motion.div>
				) : null}
			</AnimatePresence>
		</div>
	);
};

export default MiniService;
